import { AboBasicInfo } from "../BasicInfo/BasicInfo";
import ContactActions from "../ContactActions/ContactActions";
import ProfileBannerLayout from "./ProfileBannerLayout";
import useProfileBannerData from "./useProfileBannerData";

type Props = { pushToHistory?: (affAbo: string) => void };

const AboProfileBanner = ({ pushToHistory }: Props) => {
  const { aff, abo, data, isFetching, isError, refetch, isFromEdLos, edlosAboMeta, isRootAbo, tags } =
    useProfileBannerData();
  const {
    aboInfo,
    partyInfo,
    pinAwardSummary,
    isPlatinumOrAbove = false,
    isEmeraldAndAbove = false,
    isDiamondAndAbove = false,
  } = data ?? {};
  return (
    <ProfileBannerLayout
      aff={aff}
      abo={abo}
      imageRefUrl={aboInfo?.imageRefUrl}
      pushToHistory={pushToHistory}
      isFetching={isFetching}
      isError={isError}
      refetch={refetch}
      basicInfo={
        <AboBasicInfo
          aboInfo={aboInfo}
          tags={tags}
          award={{
            highestAward: pinAwardSummary?.previousPYPin?.code,
            currentAward: pinAwardSummary?.currentPin?.code,
            currentAwardDate: pinAwardSummary?.currentPin?.qualPeriod,
            isPlatinumOrAbove,
            isEmeraldAndAbove,
            isDiamondAndAbove,
          }}
          isLoading={isFetching}
          isConfidential={aboInfo?.privacyFlag}
          isRootAbo={isRootAbo}
          isFromEdLos={isFromEdLos}
          edlosAboMeta={edlosAboMeta}
        />
      }
      contacts={
        <ContactActions
          partyInfo={partyInfo}
          isLoading={isFetching}
          isConfidential={aboInfo?.privacyFlag}
          isKoreaMarket={aboInfo?.countryCode?.toUpperCase() === "KR"}
        />
      }
    />
  );
};

export default AboProfileBanner;
